import React from 'react';
import { PinFillMedium } from '@blueprint/icons';
import { StyledRightButtonWithIcon } from './MobileQuickMenu.styles';
import { trackMapViewClick } from './MobileQuickMenu.tracking';
import { useRouter } from 'next/router';
import { removePageSpecificParams } from 'search/helpers/removePageSpecificParams';

const MapViewButton: React.FC = () => {
    const { asPath } = useRouter();

    const href = `/${asPath.split('/')[1]}${asPath.replace(
        /(for-sale|to-rent|new-homes)/,
        'map'
    )}`;
    const mapViewPath = removePageSpecificParams(href);

    return (
        <StyledRightButtonWithIcon
            variant="secondary"
            isFullWidth
            href={mapViewPath}
            onClick={trackMapViewClick}
            data-testid="map-view"
        >
            <PinFillMedium />
            Map view
        </StyledRightButtonWithIcon>
    );
};

export default MapViewButton;
